import React from 'react';
import { FormattedMessage } from 'react-intl';

export default {
  REMOVE_AGENT_FROM_BO: <FormattedMessage id="remove-agent-from-bo" defaultMessage="Remove From BO" />,
  CANCEL: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
  CONFIRM: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
  REMOVE_AGENT: <FormattedMessage id="remove-agent" defaultMessage="Remove Agent" />,
};
